import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import { Lists_canbo } from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';

const swal = require('sweetalert');
@Component({
  selector: 'app-tonghop-dsloaikhoanedit',
  templateUrl: './dsloaikhoanedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./dsloaikhoanedit.component.scss'],
    providers: [ListService, Repository]
})
export class dsloaikhoaneditComponent implements OnInit {

    
  
    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
      precision: 0,
      allowNegative: true
    };

    donviid: any;
    tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = {
      ChiTiet: {
        Id: null
      }
    
      , DoiTuongs: {
        Tich: null, Id: null, Ma: null, Ten: null
      }
      , DataTieuDe: null, DataTieuDeCot:null
      , DoiTuong_TimKiems: null
      };    
      nhomdtid:string=null;
      @Output() save: EventEmitter<any> = new EventEmitter();
  
      constructor( private _dataService: ListService, private repo: Repository) {
       
        
      }

      ngOnInit(): void {
      

    }

    Tich(value) {
      this.doituongSelect.DoiTuong_TimKiems.forEach((item: any) => {
        if (item.Id == value.Id)
          item.Tich = value.Tich;
      });
    }
  
 
    changesearch(value) {
      let datatam = this.doituongSelect.DoiTuong_TimKiems;
      //console.log(datatam);
      this.doituongSelect.DataTieuDe.forEach((item: any) => {
        if (item.TimKiem != null && item.TimKiem != "") {
          datatam = datatam.filter((s) => s[item.ColumnName] !== null && s[item.ColumnName].toString().toLowerCase().indexOf(item.TimKiem.toLowerCase()) !== -1);

        }
      });
      this.doituongSelect.DoiTuongs = datatam;

    }
  
    comboSearchFn(term: string, item: any) {
      term = term.toLowerCase();
      return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
    }
  
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        this.donviid = data.id_don_vi;
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        
      this.doituongSelect = {
        ChiTiet: {
          Id: null
        }

        , DoiTuongs: {
          Tich: null, Id: null, Ma: null, Ten: null
          }
        , DataTieuDe: null, DataTieuDeCot: null
        , DoiTuong_TimKiems: null
      };    

      this.doituongSelect.ChiTiet.Id = id;

      this.repo.postRequest("api/bc31/getloaikhoan", { Id: id, DonViId: donviid })
        .subscribe(response => {
          this.doituongSelect.ChiTiet = response.ChiTiet;
          this.doituongSelect.DoiTuongs = response.DoiTuongs;
          this.doituongSelect.DoiTuong_TimKiems = response.DoiTuongs;
          this.doituongSelect.DataTieuDe = response.DataTieuDe;
        }); 
      
    
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {


     
    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
      
  public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    this.doituongSelect.DoiTuongs = this.doituongSelect.DoiTuong_TimKiems;
    this.save.emit(this.doituongSelect.DoiTuongs);
    }
   

}


